import React, { Component } from 'react';
import swal from 'sweetalert2';
import { Form } from 'react-form';
import { isValidNumber } from 'libphonenumber-js';
import { abonnerEcourrierE3 } from '../../../App_Code/API';
import { AfficherFeedback, Texte } from '../../ChampFormulaire';

class PageNumeroMobile extends Component {
    constructor(props) {
        super(props);

        if (props.location && props.location.search) {
            const params = new URLSearchParams(props.location.search);
            this.token = params.get('token');
        }

        this.telInput = React.createRef();
        this.envoyerInput = React.createRef();
    }

    componentDidMount() {
        if (!this.token) {
            this.props.history.push('/');
        }
    }

    handleSubmit = (submittedValues) => {
        const { tel } = submittedValues;
        const { token, telInput, envoyerInput } = this;
        const { history } = this.props;
        envoyerInput.current.disabled = true;

        const telValide = tel !== undefined && (isValidNumber(tel, 'FR') || isValidNumber(tel));
        AfficherFeedback(telInput, telValide);

        if (!telValide) {
            envoyerInput.current.disabled = false;
            return;
        }

        const data = {
            Tel: tel,
            Code: (Math.floor((999999 - 100001) * Math.random()) + 100000).toString(),
        };

        abonnerEcourrierE3(token, data).then((ok) => {
            if (ok) {
                history.push({
                    pathname: '/Ecourrier/SMSCode',
                    state: { token, data },
                });
            } else {
                swal('Erreur', "Une erreur est survenue durant l'envoi du SMS.", 'error');
                envoyerInput.current.disabled = false;
            }
        });
    };

    render() {
        return (
            <Form onSubmit={this.handleSubmit}>
                {formApi => (
                    <form onSubmit={formApi.submitForm}>
                        <h5 className="card-title">Abonnement au service courrier électronique</h5>
                        <div className="form-group required">
                            <label htmlFor="EcourrierTel">Téléphone portable</label>
                            <Texte
                                id="EcourrierTel"
                                field="tel"
                                placeholder="Téléphone portable"
                                type="text"
                                refRef={this.telInput}
                            />
                            <div className="invalid-feedback">
                                Veuillez renseigner un numéro de téléphone mobile valide
                            </div>
                        </div>
                        <button type="submit" className="btn btn-block btn-lg btn-success" ref={this.envoyerInput}>
                            Envoyer le code de vérification
                        </button>
                    </form>
                )}
            </Form>
        );
    }
}

export default PageNumeroMobile;



// WEBPACK FOOTER //
// ./src/components/Adherent/Ecourrier/PageNumeroMobile.js